import type { GameCategory } from '$lib/category';
import { GAME_CATEGORIES } from '$lib/category';

export const match = (param: GameCategory) => {
	return GAME_CATEGORIES.includes(param);
};
